import { type HTMLProps, forwardRef } from 'react';

import * as styles from './Tooltip.css';
type ButtonProps = HTMLProps<HTMLButtonElement>;
type SpanProps = HTMLProps<HTMLSpanElement>;

export const TooltipButtonWrapper = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children }, ref) => (
    <button ref={ref} tabIndex={0} className={styles.overrideDefault}>
      {children}
    </button>
  ),
);

export const TooltipSpanWrapper = forwardRef<HTMLSpanElement, SpanProps>(
  ({ children }, ref) => (
    <div>
      <span ref={ref}>{children}</span>
    </div>
  ),
);
